Vue.component("enroll", {
    props: {
        user: {
            required: true,
        },

        course: {
            required: true,
        },

        donations: {
            required: false,
            default: false,
        },

        scriptendpoint: ""
    },

    data: function () {
        return {
            redirect_form_key: [],
            option: null,
            course_total: 0,
            course_type: "full",
            id_number: null,
            address: {
                street_name: "",
                building: "",
                suburb: "",
                city: "",
                province: "",
                country: "",
                postal_code: "",
                errors: [],
            },
            contact: {
                first_name: "",
                last_name: "",
                email: "",
                contact_number: "",
                errors: [],
            },
            instantlink: "",
            payment_token: "",
            instant_eft_success: false,
            couponApplied: false,
            forms: {
                enroll: $.extend(
                    true,
                    new AppForm({
                        busy: false,
                        paymentOption: null,
                        card: null,
                        donations: 0,
                        terms: false,
                    }),
                    App.forms.enroll
                ),
                addingNewCard: false,
            },
            newcard: {
                number: "",
                holder: "",
                exp_month: "",
                exp_year: "",
                cvv: "",
                return: "",
                errors: [],
            },
            threeDs: {
                url: "",
                connector: "",
                MD: "",
                TermUrl: "",
                PaReq: "",
            },
            readyForThreeDs: false,
            dataLayer: [],
            checkoutId: null,
            entityId: null
        };
    },

    ready: function () {
        if (this.user.id_number != "") {
            this.id_number = this.user.id_number;
        }

        if (this.user.addresses[0]) {
            this.address.street_name = this.user.addresses[0].line_one;
            this.address.suburb = this.user.addresses[0].line_two;
            this.address.province = this.user.addresses[0].province;
            this.address.country = this.user.addresses[0].country;
            this.address.city = this.user.addresses[0].city;
            this.address.postal_code = this.user.addresses[0].area_code;
        }

        if (this.user) {
            this.contact.first_name = this.user.first_name;
            this.contact.last_name = this.user.last_name;
            this.contact.email = this.user.email;
            this.contact.contact_number = this.user.cell;
        }

        this.course.semester_price =
            this.course.semester_price != "" ? this.course.semester_price : 0;
        window.addEventListener("message", (event) => {
            if (typeof event.data == "string") {
                try {
                    eval(event.data);
                    setTimeout(() => {
                        this.forms.enroll.busy = false;
                        swal.close();
                    }, 2000);
                } catch (e) {
                    this.forms.enroll.busy = false;
                    // swal.close()
                }
            }
        });
    },

    mounted() {
        this.loadPeachScript();
    },

    methods: {
        loadPeachScript: function() {
            return new Promise((resolve, reject) => {
                if (window.Checkout) {
                    return resolve();
                }

                const script = document.createElement("script");
                script.src = this.scriptendpoint;
                script.onload = resolve;
                script.onerror = reject;

                document.head.appendChild(script);
            });
        },

        closeModal() {
            $("#checkout_model").modal("hide");
            this.checkoutId = null;
        },

        handleSuccess(event) {
            this.closeModal();
        },

        popEft() {
            
            if (!this.validate()) {
                return;
            }

            this.process();
            this.forms.enroll.busy = true;
            if (this.forms.enroll.donations && this.option == "yearly") {
                this.fieldValidate();
            } else {
                this.getEftLink();
            }
        },
        fieldValidate() {
            var payload = {
                id_number: this.id_number,
                street_name: this.address.street_name,
                building: this.address.building,
                suburb: this.address.suburb,
                city: this.address.city,
                province: this.address.province,
                country: this.address.country,
                postal_code: this.address.postal_code,
            };
            this.processPayment();

            this.$http
                .post("checkout/validate", payload)
                .success(function (response) {
                    swal(
                        "Error",
                        "Donation details validation failed!",
                        "warning"
                    );
                    this.forms.enroll.busy = false;
                    swal.close();
                    this.getEftLink();
                })
                .error(function (errors) {
                    this.address.errors = errors;
                    this.forms.enroll.busy = false;
                    swal.close();
                    this.forms.enroll.errors.set(errors);
                });
        },
        coursetotalCalculate() {
          
            if (this.option == "monthly") {
                this.course_total = this.course.monthly_enrollment_fee;
            }
          
            if (this.option == "yearly") {
                if (
                    this.course.course_intake_type == "on_demand" &&
                    this.course.course_type == "short" &&
                    this.course.black_friday_discounts &&
                    this.course.black_friday_price > 0
                ) {
                    this.course_total = this.course.black_friday_price;
                } else {
                    this.course_total = this.course.annual_discounted_price;
                }

                if (this.course.type_of_course == "semester") {
                    if (this.course_type == "partially") {
                        this.course_total = this.course.semester_price;
                    }
                    if (this.course_type == "full") {
                        if (
                            this.course.course_intake_type == "on_demand" &&
                            this.course.course_type == "short" &&
                            this.course.black_friday_discounts &&
                            this.course.black_friday_price > 0
                        ) {
                            this.course_total = this.course.black_friday_price;
                        } else {
                            this.course_total =
                                this.course.semester_price *
                                this.course.no_of_semesters;
                        }
                    }
                }
            }
        },
        addCard() {
            this.newcard.return = `/courses/enroll/${this.course.reference}?threeDs=yes`;

            this.processPayment();

            this.$http
                .post("/account/billing", this.newcard)
                .then((response) => {
                    if (
                        response.data.redirect === undefined ||
                        response.data.redirect === null
                    ) {
                        this.saveCard(response.data.id);
                        this.forms.addingNewCard = false;
                    } else {
                        this.threeDs.url = response.data.redirect.url;
                        for (
                            var i =
                                response.data.redirect.parameters.length - 1;
                            i >= 0;
                            i--
                        ) {
                            this.redirect_form_key.push({
                                form_key:
                                    response.data.redirect.parameters[i].name,
                                form_value:
                                    response.data.redirect.parameters[i].value,
                            });
                            this.threeDs[
                                response.data.redirect.parameters[i].name
                            ] = response.data.redirect.parameters[i].value;
                        }
                        this.readyForThreeDs = true;
                        swal.close();
                    }
                })
                .catch((errors) => {
                    this.newcard.errors = errors.data;
                    swal.close();
                });
        },

        saveCard(id) {
            this.$http
                .post("/account/billing/card", { id: id })
                .then((response) => {
                    this.user.cards.push(response.data.card);
                    this.forms.enroll.card = response.data.card.id;
                    swal.close();
                })
                .catch((errors) => {
                    if (errors.number) {
                        swal({
                            type: "error",
                            title: "Whoops",
                            text: errors.number,
                        });
                    }
                });
        },
        applyCouponCode: function () {
            let $cid = $("input[name=course_id]").val();
            let data = this.serializeData(
                $("#Coupon_code_apply").serializeArray()
            );

            this.$http.post("/check/" + $cid, data).success((response) => {
                if (response.status == 1) {
                    this.couponApplied = true;
                    $courseObj = JSON.parse(response.object);
                    this.course.annual_discounted_price =
                        $courseObj.annual_discounted_price;
                } else {
                    swal({
                        type: "error",
                        title: "Error",
                        text: response.message,
                    });
                }
            });
        },
        serializeData: function (a) {
            var o = {};

            $.each(a, function () {
                if (o[this.name]) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || "");
                } else {
                    o[this.name] = this.value || "";
                }
            });
            return o;
        },
        cancelPayment: function () {
            this.forms.enroll.busy = false;
        },

      
        getEftLink: async function () {
           
            this.processPayment();

            this.showModal = true;
            await this.loadPeachScript();


            let data = {
                course: this.course.id,
                option: this.option,
                course_type: this.course_type,
                donation_amount: this.getDonations(),
                is_black_friday: 1,
            };

             this.$http
                .post("/instant-eft", data)
                .then(async response => {
                    const res = response.data;

                    if (!res.checkoutId || !res.entityId) {
                        return;
                    }

                    this.checkoutId = res.checkoutId;
                    this.entityId = res.entityId;

                    await this.$nextTick();

                    $("#checkout_model").modal("show");

                    setTimeout(() => {
                        swal.close();
                        this.initCheckout();
                    }, 300);
                })
                .catch(error => {
                    let message = "Unable to process your request!";

                    if (error.status == 422) {
                        message = error.data.message;
                    }

                    swal({
                        type: "warning",
                        title: "Error",
                        text: message,
                        showConfirmButton: true
                    });
                    this.forms.enroll.busy = false;
                    return;
                });
        },

        initCheckout: function() {
            const checkout = window.Checkout.initiate({
                key: this.entityId,
                checkoutId: this.checkoutId,

                options: {
                    theme: {
                        brand: {
                            primary: "#ff0000"
                        },
                        cards: {
                            background: "#00ff00",
                            backgroundHover: "#F3F3F4"
                        }
                    },

                    paymentMethods: {
                        include: [
                            "CARD",
                            "OZOW",
                            "MASTERPASS",
                            "MOBICRED",
                            "PAYFLEX",
                            "1FORYOU",
                            "PAYSHAP",
                            "PAYBYBANK",
                            "CAPITECPAY",
                            "NEDBANKDIRECTEFT",
                            "ABSAEFT",
                            "PEACHEFT"
                        ]
                    },

                    ordering: {
                        OZOW: 1,
                        CARD: 2,
                        MASTERPASS: 3,
                        MOBICRED: 4,
                        PAYFLEX: 5,
                        "1FORYOU": 6,
                        PAYSHAP: 7,
                        PAYBYBANK: 8,
                        CAPITECPAY: 9,
                        NEDBANKDIRECTEFT: 10,
                        ABSAEFT: 11,
                        PEACHEFT: 12
                    }
                },

                events: {
                    onCompleted: event => {
                      const resultCode = event.result.code || "";

                        const message =
                            event.result.description ||
                            "Payment response received";

                        const isSuccess = /^(000\.000\.|000\.100\.1|000\.[36]|000\.400\.[1][12]0)/.test(
                            resultCode
                        );

                        if (isSuccess) {
                            swal({
                                type: "success",
                                title: "Payment Successful",
                                text: message,
                                showConfirmButton: true
                            });
                            this.instant_eft_success = true;
                            this.sendRegistration();
                        } else {
                            swal({
                                type: "error",
                                title: "Payment Failed",
                                text: message,
                                showConfirmButton: true
                            });

                            this.forms.enroll.busy = false;
                            return;
                        }
                    },
                    onCancelled: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text: "Your Payment has Cancelled, please try again"
                        });
                        swal.close();
                        this.forms.enroll.busy = false;
                    },
                    onExpired: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text:
                                "Your Payment has Session Expired, please try again"
                        });
                        swal.close();
                        this.forms.enroll.busy = false;
                    }
                },

            });
            checkout.render("#payment-form");
        },

        startListener: function () {
            var pusher = new Pusher("5e9e56a5a0ebaf5484b0", {
                cluster: "mt1",
            });

            var channel = pusher.subscribe("instantefts");

            channel.bind(
                "App\\Events\\InstantEftNotificationReceived",
                (data) => {
                    if (this.payment_token == data.payment_key) {
                        if (data.success === true) {
                            this.process();
                            this.instant_eft_success = true;
                            this.sendRegistration();
                        } else {
                            this.cancelPayment();
                            swal({
                                type: "error",
                                title: "Error",
                                text: "Your Payment has failed, please try again",
                            });
                        }
                    }
                }
            );
        },

   
        process: function () {
            swal({
                title: "",
                text: '<i id="busy" class="fa fa-spinner fa-pulse" style="font-size: 8em; color: #ffffff;"></i>',
                html: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: false,
                showConfirmButton: false,
                closeOnCancel: false,
                customClass: "no-bg",
            });
        },
        processPayment: function () {
            swal({
                type: "warning",
                title: "Payment Processing",
                text: "Please wait while we are processing your payment.Do not Refresh page or close browser",
            });
        },

        beginCheckout: function () {
           
            window.dataLayer = window.dataLayer || [];

            var items = [];

            items.push({
                item_id: String(this.course.id),
                item_name: this.course.title,
                item_category: this.course.course_type,
                price: parseFloat(parseFloat(this.course_total).toFixed(2)),
                quantity: 1
            });

            window.dataLayer.push({ ecommerce: null });

            window.dataLayer.push({
                event: "begin_checkout",
                ecommerce: {
                    value: parseFloat(parseFloat(this.course_total).toFixed(2)),
                    currency: "ZAR",
                    items: items
                },
                email: this.user.email || undefined,
                cell: this.user.cell || undefined,
            });
        },

        sendTransactions: function (invoice) {
            
            window.dataLayer = window.dataLayer || [];

            var items = [];
         
         
            if (invoice.items && invoice.items.length > 0) {
                invoice.items.forEach((item) => {
                    items.push({
                        item_id: String(item.item_id),
                        item_name: item.name,
                        item_category: this.course.course_type,
                        price: parseFloat(parseFloat(item.price).toFixed(2)),
                        quantity: item.quantity
                    });
                });
            }

            window.dataLayer.push({ ecommerce: null });

            window.dataLayer.push({
                event: "purchase",
                ecommerce: {
                    transaction_id: invoice.reference,
                    value: parseFloat(parseFloat(invoice.total).toFixed(2)),
                    currency: "ZAR",
                    items: items
                },
                payment_method: this.getPaymentMethod() || undefined,
                payment_status: invoice.paid == 1 ?  "successful" : "failed",
                email: this.user.email || undefined,
                cell: this.user.cell || undefined,
            });

            console.log("done");
        },


        getPaymentMethod:function(){
             
            if(this.forms.enroll.paymentOption == 'cc'){
              return  'Credit Card';
            }  
            
            if(this.forms.enroll.paymentOption == 'eft'){
              return  'Instant EFT';
            }  

            return "";
        },

     

        register: function () {
            this.forms.enroll.errors.forget();
            this.forms.enroll.busy = true;
            // this.process();
            this.sendRegistration();
        },

        
        sendRegistration: function () {

            if (!this.validate()) {
                return;
            }
        

            if (
                this.forms.enroll.paymentOption == "eft" &&
                this.instant_eft_success == false
            ) {
                this.forms.enroll.busy = true;
                return;
            }

            if (
                this.forms.enroll.paymentOption == "cc" &&
                !this.forms.enroll.card
            ) {
                swal({
                    type: "warning",
                    title: "Error",
                    text: "Unable to purchase without credit card, please select credit card",
                });

                this.forms.enroll.busy = false;
                return;
            }

            var payload = {
                course: this.course.id,
                course_type: this.course_type,
                terms: this.forms.enroll.terms,
                card: this.forms.enroll.card,
                paymentOption: this.forms.enroll.paymentOption,
                enrollmentOption: this.option,
                donations: this.getDonations(),
                id_number: this.id_number,
                street_name: this.address.street_name,
                building: this.address.building,
                suburb: this.address.suburb,
                city: this.address.city,
                province: this.address.province,
                country: this.address.country,
                postal_code: this.address.postal_code,
                first_name: this.contact.first_name,
                last_name: this.contact.last_name,
                email: this.contact.email,
                contact_number: this.contact.contact_number,
            };
            if (this.forms.enroll.enrollmentOption != "student_loan") {
                this.processPayment();
                this.beginCheckout();
            }

    
            this.$http
                .post(
                    "/courses/checkout/" + this.course.reference + "/complete",
                    payload
                )
                .success(function (response) {
                    this.forms.enroll.busy = false;
                    if (this.option != "student_loan") {
                        swal.close();
                    }
                    if (this.option == "student_loan") {
                        swal({
                            type: "success",
                            title: "success",
                            text: response.message,
                        });

                        setTimeout(() => {
                            swal.close();
                            window.location = "/dashboard/courses";
                        }, 2000);
                    } else {
                      
                        if (response.invoice !== undefined) {
                          
                            this.sendTransactions(response.invoice);
                        }

                     
                        window.location = "/dashboard/courses";
                    }
                })
                .error(function (errors) {
                
                    this.address.errors = errors;
                    this.forms.enroll.busy = false;
                    swal.close();

                    if (this.option == "student_loan") {
                        this.contact.errors = errors;
                    }
                    this.forms.enroll.errors.set(errors);
                });
        },

        /*
         * Calculate the donation
         */
        getDonations: function () {
            var total = 0;
            if (this.forms.enroll.donations && this.option == "yearly") {
                total = this.donations;
            }
            return total;
        },

          validate: function() {
            if (this.forms.enroll.donations) {
                if (
                    !this.id_number ||
                    !this.id_type ||
                    !this.country_of_issue ||
                    !this.incometax_reference_number ||
                    !this.date_of_birth ||
                    !this.post_code ||
                    !this.postal_address
                ) {
                    swal({
                        type: "error",
                        title: "Donation Details Required",
                        text:
                            "Please complete all donation fields before proceeding."
                    });
                    this.forms.enroll.busy = false;
                    return false;
                }
            }

            if (this.option == "student_loan") {
                const { first_name, last_name, contact_number, email } =
                    this.contact || {};

                if (
                    !first_name ||
                    first_name.trim() === "" ||
                    !last_name ||
                    last_name.trim() === "" ||
                    !contact_number ||
                    contact_number.trim() === "" ||
                    !email ||
                    email.trim() === ""
                ) {
                    swal(
                        "Error",
                        "Please enter valid contact details",
                        "warning"
                    );

                    this.forms.enroll.busy = false;
                    return false;
                }
            }

            return true;
        },
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/course/enroll.js